module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"field":{"name_label":"モニタリングポイント名","copy_share_label":"共有設定（通知ユーザー）を引き継ぐ"},"msg":{"hint_name":"新しい設置場所に合わせた名前を入力してください","name_required":"モニタリングポイント名を入力してください"}},"en":{"field":{"name_label":"Monitoring Point name","copy_share_label":"Copy sharing settings"},"msg":{"hint_name":"Enter a new name suited for the new location","name_required":"Please enter a Monitoring Point name"}}}')
  delete Component.options._Ctor
}
